import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import SvgIcon from "../Icon/SvgIcon.jsx";
import "./styles/style.scss";

const ListItem = ({
  isRounded,
  isDisableFocus,
  hasExtra,
  size,
  headline,
  title,
  desc,
  icon,
  textIcon,
  color,
  bg,
  handleClick,
  ...rest
}) => {
  /**
   * Вернуть класс, применяемый для размера элемента
   *
   * @param {String} value
   * @return {String}
   */
  const getSizeClass = value => {
    const classes = {
      lg: "item-list__item--lg",
      md: "item-list__item--md",
    };

    return _.get(classes, value, ListItem.defaultProps.size);
  };

  const classNames = [
    "item-list__item",
    isDisableFocus ? "item-list__item--disable-focus" : "",
    getSizeClass(size),
    rest.className,
  ]
    .filter(name => name)
    .join(" ");

  const classNamesExtra = [
    "item-list__item-extra",
    rest.children instanceof Array &&
      rest.children?.filter(child => child).length === 2 &&
      "item-list__item-extra--space-between",
  ]
    .filter(name => name)
    .join(" ");

  return (
    <button type="button" className={classNames} onClick={handleClick} {...rest}>
      <div className="item-list__item-wrapper">
        {(icon || textIcon) && (
          <SvgIcon
            isAccent
            hasBg={isRounded}
            name={icon}
            textIcon={textIcon}
            color={color}
            bg={bg}
          />
        )}
        <div className="item-list__item-content">
          <div className="item-list__item-content-wrapper">
            {headline && <div className="item-list__item-headline">{headline}</div>}
            {title && <div className="item-list__item-name">{title}</div>}
            {desc && <div className="item-list__item-desc">{desc}</div>}
          </div>

          {rest.children && <div className={classNamesExtra}>{rest.children}</div>}
        </div>

        {hasExtra && <SvgIcon name="chevronRight" color="#AAABAD" size="lg" />}
      </div>
    </button>
  );
};

ListItem.propTypes = {
  isRounded: PropTypes.bool,
  isDisableFocus: PropTypes.bool,
  hasExtra: PropTypes.bool,
  size: PropTypes.string,
  headline: PropTypes.string,
  title: PropTypes.any.isRequired,
  desc: PropTypes.string,
  icon: PropTypes.any,
  textIcon: PropTypes.any,
  color: PropTypes.string,
  bg: PropTypes.string,
  handleClick: PropTypes.func,
};

ListItem.defaultProps = {
  isRounded: false,
  isDisableFocus: false,
  hasExtra: false,
  size: "lg",
  headline: "",
  desc: "",
  icon: "",
  textIcon: "",
  color: "",
  bg: "",
  handleClick: f => f,
};

export default ListItem;
